import {
  WorkflowConfig,
  WorkflowPageConfig,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';
import { nestedWidgetDefaults } from './nested-widget-defaults';

export function addDefaultNestedWidgetsIfNeeded(config: WorkflowConfig): void {
  onEveryWidget(config, (widget) => {
    const defaultNestedConfig = nestedWidgetDefaults[widget.name];
    if (defaultNestedConfig) {
      if (!widget.widgetConfiguration.nestedWidgets) {
        widget.widgetConfiguration.nestedWidgets = {};
      }
      Object.entries(defaultNestedConfig).forEach(([key]) => {
        if (widget.widgetConfiguration.nestedWidgets && !widget.widgetConfiguration.nestedWidgets[key]) {
          widget.widgetConfiguration.nestedWidgets[key] = structuredClone(defaultNestedConfig[key]);
        }
      });
    }
  });
}

export function onEveryWidget(config: WorkflowConfig, fn: (widget: WorkflowWidgetConfig) => void): void {
  config.permissionSections.roles.forEach((role) => {
    if (role.zones)
      Object.values(role.zones).forEach((canvasZone) => {
        if (canvasZone?.canvases.subscription) {
          Object.values(canvasZone?.canvases.subscription).forEach((canvasSubscription) => {
            if (canvasSubscription?.desktop?.pages)
              (canvasSubscription?.desktop?.pages as WorkflowPageConfig[]).forEach((page) => {
                page.widgets.forEach((widget) => {
                  fn(widget);
                });
              });
            if (canvasSubscription?.mobile?.pages)
              (canvasSubscription?.mobile?.pages as WorkflowPageConfig[]).forEach((page) => {
                page.widgets.forEach((widget) => {
                  fn(widget);
                });
              });
            if (canvasSubscription?.tablet?.pages)
              (canvasSubscription?.tablet?.pages as WorkflowPageConfig[]).forEach((page) => {
                page.widgets.forEach((widget) => {
                  fn(widget);
                });
              });
          });
        }
      });
  });
}
